<template lang="pug">
v-pagination.app-pagination(
  :key="length"
  v-model="valueInput"
  :length="length"
  v-bind="extendAttrs"
)

</template>

<script>

export default {
  name: 'AppPagination',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    length: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    valueInput: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    extendAttrs() {
      return {
        'total-visible': 9,
        color: 'redesignPrimaryDarken',
        'navigation-text-color': 'redesignBlack',
        'aria-label': 'Переключатель видимого контента',
        ...this.$attrs,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.app-pagination {

  &::v-deep button {
    border-radius: 100%;
    box-shadow: none !important;
    height: 8px;
    width: 8px !important;
    min-width: 8px;
    padding: 0px;
    font-size: 0px;
    text-indent: -9999px;
    margin: 3px;

    &:not(.v-pagination__item--active) {
      background-color: #{$redesignPrimaryLighten} !important;
    }

    &.v-pagination__navigation {
      background-color: transparent !important;
      margin: 0px 10px;
      display: none;
      pointer-events: none;
    }
  }

  &::v-deep span {
    align-items: center;
  }

}
</style>
